import { get } from '..';
import { TemplateType } from '../../constants/Types';

// eslint-disable-next-line no-shadow
export enum AssetSortCategory {
  // eslint-disable-next-line no-unused-vars
  NAME = 'name', ID = 'id', TEMPLATE_NAME = 'templateName',
}

export const AssetSortCategoryTitles = {
  [AssetSortCategory.NAME]: 'Name',
  [AssetSortCategory.ID]: 'ID',
  [AssetSortCategory.TEMPLATE_NAME]: 'Template',
};

export interface GetAssetsProps {
  locationId?: string,
  floorId?: string,
  templateId?: string,
  enableSubLocationsLookUp?: boolean,
  name?: string,
  assetId?: string,
  description?: string,
  manufacturer?: string,
  model?: string,
  serial?: string,
  textSearch?: string,
  templateType?: TemplateType,
  pageSize?: number,
  pageNumber?: number,
  sortBy?: AssetSortCategory,
  sortDescending?: boolean,
}

const getAssets = ({
  templateId = null,
  locationId = null,
  floorId = null,
  enableSubLocationsLookUp = false,
  name,
  assetId,
  description,
  manufacturer,
  model,
  serial,
  textSearch,
  templateType,
  pageSize,
  pageNumber,
  sortBy = AssetSortCategory.NAME,
  sortDescending,
}: GetAssetsProps) => {
  let requestUrl: string = 'assets/v2/all';
  if (templateId) {
    requestUrl += `?templateId=${templateId}`;
    if (locationId) requestUrl += `&buildingId=${locationId}`;
    if (floorId) requestUrl += `&floorId=${floorId}`;
  } else if (locationId) {
    requestUrl += `?buildingId=${locationId}`;
    if (floorId) requestUrl += `&floorId=${floorId}`;
  }
  if (enableSubLocationsLookUp) requestUrl += '&enableSubLocationsLookUp=true';
  if (name?.length) requestUrl += `&name=${name?.trim()}`;
  if (assetId?.length) requestUrl += `&assetId=${assetId?.trim()}`;
  if (description?.length) requestUrl += `&description=${description?.trim()}`;
  if (manufacturer?.length) requestUrl += `&manufacturer=${manufacturer?.trim()}`;
  if (model?.length) requestUrl += `&model=${model?.trim()}`;
  if (serial?.length) requestUrl += `&serial=${serial?.trim()}`;
  if (textSearch?.length) requestUrl += `&textSearch=${textSearch?.trim()}`;
  if (templateType?.length) requestUrl += `&templateType=${templateType?.trim()}`;
  if (pageSize && pageNumber >= 0) requestUrl += `&pageSize=${pageSize}&pageNumber=${pageNumber}`;
  if (sortBy) requestUrl += `&sortBy=${sortBy}`;
  if (sortDescending) requestUrl += `&sortDescending=${sortDescending}`;

  return get(requestUrl);
};

export default getAssets;
